import { render, staticRenderFns } from "./OdocTitleInput.vue?vue&type=template&id=3466cf04"
import script from "./OdocTitleInput.vue?vue&type=script&lang=js"
export * from "./OdocTitleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports